import { render, staticRenderFns } from "./BaseEmptyPage.vue?vue&type=template&id=7064adb6&"
import script from "./BaseEmptyPage.vue?vue&type=script&lang=js&"
export * from "./BaseEmptyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports